function SvgComponent(props: any) {
    return (
        <svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x={0.5} y={0.5} width={39} height={39} rx={4.5} stroke="#409089" />
            <g clipPath="url(#clip0_874_198804)">
            <path
                d="M19.167 13.333h-3.5c-1.4 0-2.1 0-2.635.273a2.5 2.5 0 00-1.093 1.092c-.272.535-.272 1.235-.272 2.635v7c0 1.4 0 2.1.272 2.635a2.5 2.5 0 001.093 1.093c.534.272 1.235.272 2.635.272h7c1.4 0 2.1 0 2.635-.272a2.5 2.5 0 001.092-1.093c.273-.535.273-1.235.273-2.635v-3.5m-10 2.5h1.395c.408 0 .611 0 .803-.046.17-.04.333-.108.482-.2.168-.102.312-.247.6-.535l7.97-7.969a1.768 1.768 0 10-2.5-2.5l-7.97 7.97c-.288.287-.432.431-.535.6-.091.149-.159.311-.2.482-.045.191-.045.395-.045.803v1.395z"
                stroke="#409089"
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            </g>
            <defs>
            <clipPath id="clip0_874_198804">
                <path fill="#fff" transform="translate(10 10)" d="M0 0H20V20H0z" />
            </clipPath>
            </defs>
        </svg>
    )
}
  
  export default SvgComponent